import React, { useContext } from 'react';

import { Menu } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Sidebar } from '@cnx-saas/design-system';
import { AppContext } from '../../app.context';
import { useViewport } from '../sidebar/hooks';

const ToolbarSidebarButton: React.FC = () => {
  const { toggleSideBar } = useContext(AppContext);
  const { isSmallerScreen } = useViewport();

  return isSmallerScreen ? (
    <Button
      onClick={toggleSideBar}
      color="primary"
      variant="text"
      size="small"
      endIcon={<Menu />}
    />
  ) : (
    <Button
      onClick={toggleSideBar}
      color="primary"
      variant="text"
      sx={{
        '& .MuiButton-endIcon': { marginLeft: 0 },
        minWidth: '36px',
      }}
      endIcon={<Sidebar />}
      size="small"
    />
  );
};

export { ToolbarSidebarButton };
